import React, { memo, useEffect, useState } from "react";
import { View, Pressable } from "react-native";
import { usePostHog } from "posthog-js/react";
import { emptySchedule, ISchedule } from "../../../../types/agent-settings";
import SettingsItem from "../common/settings-item";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import StyledText from "../../../common/ui/styled-text";
import HoursSelector from "./hours-selector";
import { useIsTemporarilyClosed } from "../../../../hooks/useIsTemporarilyClosed";

const Schedule = () => {
  const { settings, handleSaveStoreHours, validationErrors, isTestCallActive } =
    useSettingsData();
  const isTempClosed = useIsTemporarilyClosed();
  const posthog = usePostHog();

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (isTestCallActive) {
      setIsEditing(false);
    }
  }, [isTestCallActive]);

  const handleUpdateSchedule = (newSchedule: ISchedule) => {
    handleSaveStoreHours(newSchedule);
  };

  const editButton = (
    <Pressable
      className={`px-4 py-2 rounded-md flex-shrink-0 bg-gray-100 hover:bg-gray-200 border border-gray-200 ${
        isEditing ? "" : ""
      }`}
      onPress={() => {
        posthog.capture("schedule_editing", {
          editing: isEditing,
        });
        setIsEditing(!isEditing);
      }}
      disabled={isTestCallActive || isTempClosed}
    >
      <StyledText className={`text-sm text-gray-900 ${isEditing ? "" : ""}`}>
        {isEditing ? "Done" : "Edit"}
      </StyledText>
    </Pressable>
  );

  return (
    <View className="flex-1 w-full mb-5">
      <SettingsItem
        title="Store Hours"
        description="Set the times when your restaurant doors are open to customers."
        leftItem={editButton}
        disabled={isTempClosed}
      >
        <HoursSelector
          schedule={settings.schedule || emptySchedule}
          isEditing={isEditing}
          onUpdateSchedule={handleUpdateSchedule}
          validationError={
            validationErrors.schedule
              ? "Please enter valid times for all days."
              : undefined
          }
          disabled={isTestCallActive || isTempClosed}
          readonly={isTempClosed}
          showValidation={true}
        />
      </SettingsItem>
    </View>
  );
};

export default memo(Schedule);
